<template>
    <Dialog
        v-model:visible="deleteDialog"
        :style="{ width: '450px' }"
        header="Confirmar"
        :modal="true"
        @hide="$emit('hideDialog')"
    >
        <div class="d-flex align-items-center justify-content-center">
            <i
                class="pi pi-exclamation-triangle mr-3"
                style="font-size: 2rem"
            />
            <span v-if="shipment"
                >¿Seguro que deseas eliminar el envio
                <b>#{{ shipment.seguimiento }}</b
                >?</span
            >
        </div>
        <template #footer>
            <Button
                label="Cancelar"
                icon="pi pi-times"
                class="p-button-text"
                @click="$emit('cancelDeleteDialog')"
            />
            <Button
                label="Eliminar"
                icon="pi pi-trash"
                class="p-button-danger"
                :loading="loading"
                @click="deleteShipment"
            />
        </template>
    </Dialog>
</template>

<script>
export default {
    name: "DeleteDialog",
    props: {
        deleteDialog: Boolean,
        shipment: Object,
    },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        deleteShipment() {
            this.loading = true;
            this.$inertia
                .form()
                .delete(`/admin/retiro-inertia/${this.shipment.id}`, {
                    onSuccess: () => {
                        this.$emit("dispatchNotification", {
                            severity: "success",
                            summary: "Exito",
                            detail: "Envio eliminado",
                            life: 3000,
                        });
                        this.loading = false;
                        this.$emit("reloadProps");
                        this.$emit("hideDialog");
                    },
                    onError: (err) => {
                        console.error(err);
                        this.loading = false;
                        this.$emit("dispatchNotification", {
                            severity: "error",
                            summary: "Ha ocurrido un error",
                            detail: "Intenta más tarde",
                            life: 3000,
                        });
                    },
                });
        },
    },
};
</script>

<style></style>
